import React from "react";
import { motion } from "framer-motion";
import BrainCanvas from "./BrainCanvas";

export default function BilateralSection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 border-t border-white/5" data-testid="bilateral-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-primary-c mb-4">The Bridge Back to Calm</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight">Where an overwhelmed mind learns to settle.</h2>
          <p className="mt-5 text-fg/70 md:text-lg leading-relaxed">
            When stress takes hold, the thinking brain and the feeling brain fall out of step — and everything starts to feel heavier. Rhythm is the bridge that brings them back into conversation, and your whole system finally exhales. Explore the interactive map below — drag the brain and tap a glowing node to see how each beat gently reopens the line.
          </p>
        </motion.div>
      </div>
      <div className="max-w-7xl mx-auto mt-8">
        <BrainCanvas />
      </div>
    </section>
  );
}
